import { finishCourseCloning, finishJourneyCloning } from 'redux/actions/institutions';
import store, { useAppDispatch } from 'redux/store';
import { useSelector } from 'react-redux';
import pusherService from 'shared/services/pusher-service';
import t from 'react-translate';
import { AlertMessageType } from 'redux/schemas/app/alert-message';
import { addAlertMessage } from 'redux/actions/alert-messages';
import { useEffect, useRef, useState } from 'react';
import { CourseCloneModalState, LocalStorageKeysForCloning } from 'institutions/components/course-row-options';


const useCloneCourseOrJourney = () => {
  const currentInstitutionId = useSelector((state) => state.app.currentInstitutionId);
  const originalCourseCounts = useSelector(state => state.app.institutionDashboard.courseTypeCounts);
  const originalJourneyCounts = useSelector((state) => state.app.journeysDashboard.journeyTypeCounts);
  const [listOfClones, setListOfClones] = useState([]);
  const listRef = useRef(listOfClones);
  const dispatch = useAppDispatch();

  const addCloneToList = (cloneCatalogID) => {
    listRef.current.push(cloneCatalogID);
    setListOfClones(listRef.current);
  };

  const removeCloneFromList = (cloneCatalogID) => {
    setTimeout(() => {
      const indexToDelete = listRef.current.findIndex(clone => clone === cloneCatalogID);
      listRef.current.splice(indexToDelete, 1);
      setListOfClones(listRef.current);
    });
  };

  const openCourseCloneReadyChannel = (parentCourseId, newCatalogId) => {
    if (listRef.current.includes(newCatalogId)) {
      return;
    }
    addCloneToList(newCatalogId);

    const pusherChannel = pusherService.setupChannel(`public-institution-${currentInstitutionId}`);

    const channelCallback = ({
      clone_parent_id,
      course_id,
      duplication_command_id,
      user_id,
      name,
    }) => {
      if (clone_parent_id === parentCourseId) {
        const state = store.getState();
        const newClone = state.models.courseClonings.find((clone) => (clone.id === duplication_command_id));
        if (newClone && newClone.nickname === newCatalogId && listRef.current.includes(newCatalogId)) {
          const courseCloneModalState = localStorage.getItem(LocalStorageKeysForCloning.COURSE_CLONE_MODAL_STATE);
          const courseClone = {
            courseId: newClone.id,
            institutionId: currentInstitutionId,
            originalCourseCounts,
          };
          if (courseCloneModalState && courseCloneModalState === CourseCloneModalState.OPEN) {
            localStorage.setItem(
              LocalStorageKeysForCloning.NEW_COURSE_CLONE,
              JSON.stringify(courseClone),
            );
          } else {
            dispatch(finishCourseCloning(courseClone));
            localStorage.removeItem(LocalStorageKeysForCloning.NEW_COURSE_CLONE);
          }
          showSuccessMessage(newClone.nickname, name);
          removeCloneFromList(newCatalogId);
        }
      }
    };

    pusherChannel.bind('course_clone_ready', channelCallback);
  };

  const openJourneyCloneReadyChannel = (parentCourseId, newCatalogId) => {
    if (listRef.current.includes(newCatalogId)) {
      return;
    }
    addCloneToList(newCatalogId);

    const pusherChannel = pusherService.setupChannel(`public-institution-${currentInstitutionId}`);

    const channelCallback = ({
      clone_parent_id,
      journey_id,
      duplication_command_id,
      user_id,
      name,
    }) => {
      if (clone_parent_id === parentCourseId) {
        const state = store.getState();
        const newClone = state.models.journeyClonings.find((clone) => (clone.id === duplication_command_id));
        if (newClone && newClone.name === newCatalogId && listRef.current.includes(newCatalogId)) {
          dispatch(finishJourneyCloning({
            institutionId: currentInstitutionId,
            catalogId: newClone.name,
            originalJourneyCounts,
          }));
          showSuccessMessage(newClone.name, newClone.settingsHash.name, true);
          removeCloneFromList(newCatalogId);
        }
      }
    };

    pusherChannel.bind('course_clone_ready', channelCallback);
  };

  const showSuccessMessage = (catalogId, name, isJourney = false) => {
    setTimeout(() => {
      dispatch(addAlertMessage({
        type: AlertMessageType.SUCCESS,
        header: t.FORM.SUCCESS_BANG(),
        duration: Infinity,
        customElement: {
          component: 'AlertCloningMessage',
          props: {
            newClone: { nickname: catalogId, newName: name, isJourney },
          },
        },
      }));
    });
  };

  return {
    openCourseCloneReadyChannel,
    openJourneyCloneReadyChannel,
  };
};

export default useCloneCourseOrJourney;
